import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';

import { ToastContainer, toast } from 'react-toastify';
import PayrollNav from './PayrollNav.js';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../config.js'
import Pagination from '../Pagination/Paginations.js';
import EntriesSelector from '../Pagination/EntriesSelector';
import useSortData from "../Pagination/SortData";
import '../preloading.css';

import {
	statisticsAction,
	statisticsCloseAction
} from '../../actions/settingsAction.js';

const VisitorEmployee = (props) => {

	const { fixNavbar } = props;

	const { sortConfig, sortData, handleSort } = useSortData();

	const [records, setRecords] = useState([]);
	const [checkedItems, setCheckedItems] = useState({});
	const [loading, setLoading] = useState(false);
	const [saving, setSaving] = useState(false);

	const [searchTerm, setSearchTerm] = useState("");
	const [currentPage, setCurrentPage] = useState(1);
	const [entriesPerPage, setEntriesPerPage] = useState(10);

	const searchableFields = [
		"employee_id",
		"employee_name",
		"department_name",
		"designation_name",
	];

	const safe = (val) => String(val ?? "").toLowerCase();

	const filteredItems =
		searchTerm.trim() === ""
			? records
			: records.filter((item) =>
				searchableFields.some((field) =>
					safe(item[field]).includes(searchTerm.toLowerCase())
				)
			);

	const totalPages = Math.ceil(filteredItems.length / entriesPerPage);
	const indexOfLast = currentPage * entriesPerPage;
	const indexOfFirst = indexOfLast - entriesPerPage;
	const sortedItems = sortData(filteredItems);
	const filteredData = sortedItems.slice(indexOfFirst, indexOfLast);

	useEffect(() => {
		setCurrentPage(1);
	}, [searchTerm]);

	const clearInput = () => {
		setSearchTerm("");
	};

	const fetchRecords = async () => {
		setLoading(true);
		try {
			const response = await axios.get(API_BASE_URL + '/visitor_employee_list', {
				headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
			});

			const visitorList = response.data.visitor_employee_list || [];
			setRecords(visitorList);

			// every visiting employee is selected by default, same as the old screen
			const defaultChecked = visitorList.reduce((acc, item) => {
				acc[item.employee_id] = true;
				return acc;
			}, {});
			setCheckedItems(defaultChecked);
		} catch (err) {
			console.log(err);
			toast.error("Unable to load visiting employees", {
				position: "bottom-right",
				theme: "colored",
			});
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => { fetchRecords(); }, []);

	// keep the edited value on the record itself so it survives paging/search
	const handleFieldChange = (employeeId, field, value) => {
		if (value !== "" && !/^\d+$/.test(value)) return; // whole days only
		setRecords((prev) =>
			prev.map((record) =>
				record.employee_id === employeeId ? { ...record, [field]: value } : record
			)
		);
	};

	const handleSave = async (e) => {
		e.preventDefault();

		if (saving) return;

		const selected = records.filter((record) => checkedItems[record.employee_id]);

		if (selected.length === 0) {
			toast.warn("Please select at least one employee!", {
				position: "bottom-right",
				theme: "colored",
			});
			return;
		}

		const incomplete = selected.find(
			(record) => record.visiting_days === "" || record.visiting_days === null
		);

		if (incomplete) {
			toast.warn(`Visiting days is empty for employee ID ${incomplete.employee_id}`, {
				position: "bottom-right",
				theme: "colored",
			});
			return;
		}

		const visitors = selected.map((record) => ({
			employee_id: Number(record.employee_id),
			visiting_days: Number(record.visiting_days || 0),
			visitor_holidays: Number(record.visitor_holidays || 0),
		}));

		setSaving(true);

		try {
			const response = await axios.post(
				API_BASE_URL + '/add_visitor_detail',
				{ visitors: visitors },
				{
					headers: {
						"Content-Type": "application/json",
						Authorization: `Bearer ${localStorage.getItem("authToken")}`,
					},
				}
			);

			if (response.data.status == 200) {
				toast.success(response.data.message, {
					position: "bottom-right",
					theme: "colored",
				});
				fetchRecords();
			} else {
				toast.error(response.data.message || "Not able to save visitor info", {
					position: "bottom-right",
					theme: "colored",
				});
			}
		} catch (err) {
			console.log(err);
			toast.error(err?.response?.data?.message || "Server error while saving visitor info", {
				position: "bottom-right",
				theme: "colored",
			});
		} finally {
			setSaving(false);
		}
	};

	const columns = [
		{ label: "Emp Id", key: "employee_id", sortable: true },
		{ label: "Name", key: "employee_name", sortable: true },
		{ label: "Department", key: "department_name", sortable: true },
		{ label: "Working days", key: "visiting_days", sortable: true },
		{ label: "Public Holidays in working days", key: "visitor_holidays", sortable: true },
	];

	return (
		<>
			<div>
				<div>
					<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
						<div className="container-fluid">
							<ToastContainer />
						</div>
					</div>

					<PayrollNav active="/Visitor-employee" />

					<div className="section-body">
						<div className="container-fluid">
							<div className="tab-content">
								<div className="tab-pane fade show active" id="Visitor-list" role="tabpanel">
									<div className="card">

										<div className="card-header d-flex justify-content-between align-items-center">
											<h3 className="card-title d-flex align-items-center mb-0" style={{ color: "#1d3a8a", fontWeight: 600 }}>
												<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 16 16" fill="#1d3a8a" style={{ marginRight: "8px", verticalAlign: "-3px" }}>
													<path d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1zm-7.978-1L7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002-.014.002zM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4m3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0M6.936 9.28a6 6 0 0 0-1.23-.247A7 7 0 0 0 5 9c-4 0-5 3-5 4q0 1 1 1h4.216A2.24 2.24 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816M4.92 10A5.5 5.5 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275ZM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0m3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4" />
												</svg>
												List Of All Visiting Employees
											</h3>

											<div
												className="card-options"
												style={{
													display: "flex",
													alignItems: "center",
													gap: "12px",
												}}
											>
												<EntriesSelector
													entriesPerPage={entriesPerPage}
													setEntriesPerPage={setEntriesPerPage}
													setCurrentPage={setCurrentPage}
												/>

												<div style={{ position: "relative", width: "200px" }}>
													<input
														type="text"
														className="form-control form-control-sm"
														placeholder="Search"
														value={searchTerm}
														onChange={(e) => {
															setSearchTerm(e.target.value);
															setCurrentPage(1);
														}}
														style={{
															width: "100%",
															height: "30px",
															fontSize: "13px",
															borderRadius: "4px",
															paddingRight: "28px",
														}}
													/>

													{searchTerm.length > 0 && (
														<span
															onClick={clearInput}
															style={{
																position: "absolute",
																right: "8px",
																top: "50%",
																transform: "translateY(-50%)",
																cursor: "pointer",
																color: "#aaa",
																fontSize: "16px",
																userSelect: "none",
															}}
														>
															✖
														</span>
													)}
												</div>
											</div>
										</div>

										{loading && (
											<div className="card-body">
												<div className="d-flex justify-content-center">
													<div className="spinner"></div>
												</div>
											</div>
										)}

										{!loading && (
											<div className="card-body">
												<form onSubmit={handleSave}>
													<div className="table-responsive sticky-table-wrap">
														<table className="table table-hover table-striped table-vcenter text-nowrap mb-0 sticky-table">
															<thead>
																<tr>
																	<th style={{ textAlign: "center" }}>
																		<input
																			type="checkbox"
																			checked={
																				records.length > 0 &&
																				records.every((r) => checkedItems[r.employee_id])
																			}
																			onChange={(e) => {
																				const isChecked = e.target.checked;
																				const newChecked = {};
																				records.forEach((r) => {
																					newChecked[r.employee_id] = isChecked;
																				});
																				setCheckedItems(newChecked);
																			}}
																		/>
																	</th>

																	{columns.map((col) => (
																		<th
																			key={col.key}
																			onClick={col.sortable ? () => handleSort(col.key) : null}
																			style={{ cursor: col.sortable ? "pointer" : "default" }}
																		>
																			{col.label}
																			{col.sortable && (
																				sortConfig.key === col.key
																					? (sortConfig.direction === "asc" ? " ▲" : " ▼")
																					: " ⇅"
																			)}
																		</th>
																	))}
																</tr>
															</thead>
															<tbody>
																{filteredData.length > 0 ? (
																	filteredData.map((record) => (
																		<tr key={record.employee_id}>
																			<td style={{ textAlign: "center" }}>
																				<input
																					type="checkbox"
																					value={record.employee_id}
																					checked={checkedItems[record.employee_id] || false}
																					onChange={(e) => {
																						const isChecked = e.target.checked;
																						const id = record.employee_id;

																						setCheckedItems((prev) => ({
																							...prev,
																							[id]: isChecked,
																						}));
																					}}
																				/>
																			</td>
																			<td>{record.employee_id}</td>
																			<td>{record.employee_name}</td>
																			<td>{record.department_name}</td>
																			<td>
																				<input
																					className="form-control"
																					type="text"
																					placeholder="Visiting Days"
																					value={record.visiting_days ?? ""}
																					disabled={!checkedItems[record.employee_id]}
																					onChange={(e) =>
																						handleFieldChange(record.employee_id, "visiting_days", e.target.value)
																					}
																				/>
																			</td>
																			<td>
																				<input
																					className="form-control"
																					type="text"
																					placeholder="Visitor Holidays"
																					value={record.visitor_holidays ?? ""}
																					disabled={!checkedItems[record.employee_id]}
																					onChange={(e) =>
																						handleFieldChange(record.employee_id, "visitor_holidays", e.target.value)
																					}
																				/>
																			</td>
																		</tr>
																	))
																) : (
																	<tr>
																		<td colSpan="6" style={{ color: 'red', textAlign: 'center', fontWeight: "bold" }}>No records found</td>
																	</tr>
																)}
															</tbody>
														</table>
													</div>

													<Pagination
														currentPage={currentPage}
														totalPages={totalPages}
														onPageChange={setCurrentPage}
													/>

													<div className="d-flex gap-2 mt-3">
														<button type="submit" className="btn btn-primary btn-sm" disabled={saving}>
															<i className="fa fa-check-square-o" style={{ marginRight: '5px' }} />
															{saving ? "Saving..." : "Save"}
														</button>
													</div>
												</form>
											</div>
										)}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

const mapStateToProps = (state) => ({
	fixNavbar: state.settings.isFixNavbar,
	statisticsOpen: state.settings.isStatistics,
	statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
	statisticsAction: (e) => dispatch(statisticsAction(e)),
	statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})

export default connect(mapStateToProps, mapDispatchToProps)(VisitorEmployee);
